module.exports = __webpack_public_path__ + "img/SPlogo.7c46b7c1.svg";